export default "__VITE_ASSET__CWLy5ALZ__"